import DocumnetCustomerForm from "components/addcustomer/inventorydocumnet/documnetInvetory";
import AddCustomerLayout from "components/global/customerlayout/AddCustomerLayout";
import { useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

const CustomerInventoryDocument = () => {
    const { id } = useParams();
  const formRef = useRef(); 
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const inventoryId = searchParams.get("inventory");

  const dynamicName = (
    <div className="flex flex-col gap-1.5">
      <h2 className="page-heading">New Customer</h2>
    </div>
  );

  const submitButton = (
    <div className="flex items-center gap-2">

      <button
        onClick={() =>
          navigate(`/app/Customer/${id}/installment-plan?inventory=${inventoryId}`)
        }
        type="button"
        className="btn-secondary w-fit"
      >
        Skip
      </button>

      <button
        type="button"
        className="btn-primary py-2 px-6 w-fit"
               onClick={() =>
          navigate(`/app/Customer/${id}/installment-plan?inventory=${inventoryId}`)
        }
      >
        Next 
      </button>
    </div>
  );

  return (
    <AddCustomerLayout dynamicName={dynamicName} dynmicbutton={submitButton}>
      <DocumnetCustomerForm ref={formRef} /> 
    </AddCustomerLayout>
  );
};

export default CustomerInventoryDocument;
